// extracted by mini-css-extract-plugin
module.exports = {"logo":"MainLayout_logo__2YsdJ","trigger":"MainLayout_trigger__3-uho","navScroll":"MainLayout_navScroll__3exva","nav":"MainLayout_nav__31IOY"};